import React from "react";
import styles from './CTASection.module.css';

function CTASection() {
    return (
        <>
            <section className={styles.CTA}>
                <h2>Let a concierge handle it.</h2>
                <p>Join thousands of professionals who trust Oya Concierge for their lifestyle and business needs.</p>
                <button>Join Oya Concierge</button>
            </section>
        </>
    );
}

export default CTASection